import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { H4, H2, H5 } from 'UIComponents/elements/headings';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import styled from '../../../components/Theme';
import { hubspotEditPagePaths } from '../../../utils/urls';
import { useUserByUsername, useIsCurrentUser } from '../userQueries';
const Card = styled(UICardWrapper).withConfig({
  displayName: "UserGoal__Card",
  componentId: "ttvxdd-0"
})(["padding:32px 24px;margin-bottom:0 !important;box-shadow:0 8px 16px rgb(51 71 91 / 30%);"]);
const GoalCard = styled(({
  className,
  goal,
  showEdit
}) => /*#__PURE__*/_jsxs(Card, {
  className: className,
  children: [/*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UIIcon, {
      className: "m-right-1",
      name: "goal",
      size: 24
    }), /*#__PURE__*/_jsx(H4, {
      style: {
        display: 'inline-block',
        fontWeight: 500
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "connectDotCom.currentGoal"
      })
    })]
  }), /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(H2, {
      style: {
        fontWeight: 700,
        display: 'inline',
        marginRight: 8
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `connectDotCom.goals.${goal}`
      })
    }), showEdit && /*#__PURE__*/_jsx(H5, {
      style: {
        display: 'inline',
        whiteSpace: 'nowrap'
      },
      children: /*#__PURE__*/_jsx(UILink, {
        href: hubspotEditPagePaths.edit(),
        use: "on-dark",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.editGoal"
        })
      })
    })]
  })]
})).withConfig({
  displayName: "UserGoal__GoalCard",
  componentId: "ttvxdd-1"
})(["background-color:", ";color:", ";"], props => props.theme.colors.THUNDERDOME_DARK, props => props.theme.colors.OLAF);

const UserGoal = ({
  username
}) => {
  const {
    user
  } = useUserByUsername(username);
  const showEdit = useIsCurrentUser(user ? user.userId : undefined);
  const {
    networkGoal
  } = user || {};
  if (!networkGoal) return null;
  return /*#__PURE__*/_jsx(GoalCard, {
    goal: networkGoal,
    showEdit: showEdit
  });
};

export default UserGoal;